import { create } from "zustand";
import { persist } from "zustand/middleware";

type TestRecords = {
  columns: any[];
  handleColumns: (data: any[]) => void;
  views: any;
  handleViews: (data: any) => void;
};

/**
 * State Management for Test Records
 * @dynamic
 * @hook {function}
 */
export const useTestRecords = create(
  persist<TestRecords>(
    set => ({
      columns: [],
      views: null,
      handleColumns: (data: any[]) => {
        set(() => ({
          columns: data,
        }));
      },
      handleViews: (data: any) => {
        set(() => ({
          views: data,
        }));
      },
      clearAll: () =>
        set({
          columns: [],
        }),
    }),
    {
      name: "useTestRecords-storage",
    }
  )
);
